import type { ReactElement, ReactNode } from 'react';

interface FieldProps {
  readonly label: string;
  readonly htmlFor: string;
  readonly children: ReactNode;
}

/** Labeled field wrapper shared across the care-team editor sections. */
export function Field({ label, htmlFor, children }: FieldProps): ReactElement {
  return (
    <div className="block space-y-1.5">
      <label
        htmlFor={htmlFor === '' ? undefined : htmlFor}
        className="block text-[10.5px] font-semibold uppercase tracking-[0.1em] text-muted-foreground"
      >
        {label}
      </label>
      {children}
    </div>
  );
}
